import React from "react";
import { formatDate } from "../../../Helper/FromatTime.js";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import "../../../asset/new/css/employer-modern.css";

const EmployerSubscriptions = ({ salesHistory }) => {
  const userId = localStorage.getItem("id");

  function formatTimestamp(utcTimestamp) {
    const dateObject = new Date(utcTimestamp);
    return dateObject
      .toISOString()
      .replace(/T/, "  ")
      .replace(/\.\d+Z$/, "");
  }

  const isExpired = (expires_in) => new Date(expires_in) < new Date();

  return (
    <div>
      {salesHistory?.length > 0 ? (
        <div className="employer-card">
          <div className="employer-card-header">
            <h3 className="employer-card-title">Package Balance</h3>
          </div>
          <div className="employer-card-body">
            <div className="employer-stats-grid">
              {salesHistory
                ?.filter((item) => item?.is_active)
                .map((value) => (
                  <div className="employer-card" key={value?._id}>
                    <div className="employer-card-header">
                      <div className="employer-flex employer-items-center employer-justify-between">
                        <h4 className="employer-card-title" style={{ margin: 0 }}>
                          {value?.package?.name}
                        </h4>
                        <span
                          className={`employer-badge ${
                            isExpired(value?.expires_in)
                              ? "employer-badge-danger"
                              : "employer-badge-success"
                          }`}
                        >
                          {isExpired(value?.expires_in) ? (
                            <><FaTimesCircle /> Expired</>
                          ) : (
                            <><FaCheckCircle /> Active</>
                          )}
                        </span>
                      </div>
                    </div>
                    <div className="employer-card-body">
                      <div className="employer-form-group">
                        <div className="employer-flex employer-gap-3" style={{ fontSize: '0.875rem' }}>
                          <div style={{ flex: 1 }}>
                            <div style={{ color: 'var(--employer-text-muted)', marginBottom: '0.25rem' }}>
                              Purchased
                            </div>
                            <div style={{ fontWeight: 600, color: 'var(--employer-text-primary)' }}>
                              {value?.package?.name === "Job Posting" ||
                              value?.package?.name === "Bulk Job Posting"
                                ? value?.package?.no_job_posting
                                : value?.package?.no_cv_search}
                            </div>
                          </div>
                          <div style={{ flex: 1 }}>
                            <div style={{ color: 'var(--employer-text-muted)', marginBottom: '0.25rem' }}>
                              Used
                            </div>
                            <div style={{ fontWeight: 600, color: 'var(--employer-text-primary)' }}>
                              {value?.package?.name === "Job Posting" ||
                              value?.package?.name === "Bulk Job Posting"
                                ? value?.package?.no_job_posting - value?.avail_jobposting
                                : value?.package?.no_cv_search - value?.avail_cvsearch}
                            </div>
                          </div>
                          <div style={{ flex: 1 }}>
                            <div style={{ color: 'var(--employer-text-muted)', marginBottom: '0.25rem' }}>
                              Available
                            </div>
                            <div style={{ fontWeight: 600, color: 'var(--employer-primary)' }}>
                              {value?.package?.name === "Job Posting" ||
                              value?.package?.name === "Bulk Job Posting"
                                ? value?.avail_jobposting
                                : value?.avail_cvsearch}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="employer-form-group" style={{ marginBottom: 0 }}>
                        <div style={{ fontSize: '0.875rem', color: 'var(--employer-text-muted)' }}>
                          Valid till: <strong style={{ color: 'var(--employer-text-primary)' }}>{formatDate(value?.expires_in)}</strong>
                          <span style={{ marginLeft: '0.5rem' }}>
                            ({value?.package?.validity_day} Days)
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default EmployerSubscriptions;
